import { Role } from "../AppTypes";

export interface User extends AuthProfile {
  impersonatedUser: AuthProfile | null;
}

export enum UserPreferenceEnum {
  HIDE_ROLE = "HIDE_ROLE",
}

export interface AuthProfile {
  id: number;
  name: string;
  surname: string;
  isCm: boolean;
  role: Role;
  enableImpersonate: boolean;
  restrictedCollaboratorIds: number[];
  userPreferences: UserPreferenceEnum[];
}

export type GetAuthProfileResponse = User;
